import { Routes, Route, Navigate } from 'react-router-dom'
import { Toaster } from 'sonner'
import LandingPage from './pages/LandingPage'
import GeniusProfile from './pages/genius-profile'
import ClientProfile from './pages/client-profile'
import CoursesPage from './pages/CoursesPage'
import CourseDetailPage from './pages/CourseDetailPage'
import LessonPage from './pages/LessonPage'
import Onboarding from './pages/Onboarding'
import AdminPage from './pages/AdminPage'
import FreelancerPublicProfile from './pages/genius/[id]'
import PublicClientProfile from './pages/client/[id]'
import ClientDashboard from './pages/client/ClientDashboard'
import ClientSearchData from './pages/ClientSearchData'
import FeaturedFreelancers from './pages/FeaturedFreelancers'
import ProtectedRoute from './components/ProtectedRoute'
import AdminRoute from './components/AdminRoute'
import Layout from './components/Layout'
import { DashboardRedirect } from './components/DashboardRedirect'
import { ProfileEnabledGuard } from './components/ProfileEnabledGuard'
import { RoleBasedGuard } from './components/RoleBasedGuard'

// New pages
import FreelancerDashboard from './pages/genius/FreelancerDashboard'
import FreelancerReviewStatus from './pages/genius/FreelancerReviewStatus'
import DisabledProfilePage from './pages/genius/DisabledProfilePage'
import SsoCallback from './pages/SsoCallback'
import SignInPage from './pages/sign-in'
import SignUpPage from './pages/sign-up'
import ForgotPasswordPage from './pages/forgot-password'
import ResetPasswordPage from './pages/reset-password'
import Chat from './pages/Chat'
import CertificationHub from './pages/genius/CertificationHub'
import SkillLandingPage from './pages/experts/SkillLandingPage'
import ExpertsIndexPage from './pages/experts/ExpertsIndexPage'
import BlogListingPage from './pages/blog/BlogListingPage'
import BlogArticlePage from './pages/blog/BlogArticlePage'

function App() {
  return (
    <>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/genius/:id" element={<FreelancerPublicProfile />} />
        <Route path="/experts" element={<ExpertsIndexPage />} />
        <Route path="/experts/:skillSlug" element={<SkillLandingPage />} />
        <Route path="/blog" element={<BlogListingPage />} />
        <Route path="/blog/:slug" element={<BlogArticlePage />} />
        <Route path="/sign-in" element={<SignInPage />} />
        <Route path="/sign-up" element={<SignUpPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/sso-callback" element={<SsoCallback />} />

        {/* Protected routes */}
        <Route element={<ProtectedRoute />}>
          <Route path="/onboarding" element={<Onboarding />} />

          <Route element={<Layout />}>
            <Route element={<RoleBasedGuard />}>
              {/* Dashboard redirect - redirects to role-specific dashboard */}
              <Route path="/dashboard" element={<DashboardRedirect />} />

              {/* Genius (Freelancer) routes - nested under /genius */}
              <Route element={<ProfileEnabledGuard />}>
                <Route path="/genius/disabled" element={<DisabledProfilePage />} />
                <Route path="/genius/dashboard" element={<FreelancerDashboard />} />
                <Route path="/genius/profile" element={<GeniusProfile />} />
                <Route path="/genius/courses" element={<CoursesPage />} />
                <Route path="/genius/course/:slug" element={<CourseDetailPage />} />
                <Route path="/genius/lesson/:lessonId" element={<LessonPage />} />
                <Route path="/genius/review-status" element={<FreelancerReviewStatus />} />
                <Route path="/genius/analytics" element={<ClientSearchData />} />
                <Route path="/genius/chat" element={<Chat />} />
                <Route path="/genius/certification" element={<CertificationHub />} />
              </Route>

              {/* Client routes - nested under /client */}
              <Route path="/client/dashboard" element={<ClientDashboard />} />
              <Route path="/client/search" element={<ClientDashboard />} />
              <Route path="/client/profile" element={<ClientProfile />} />
              <Route path="/client/featured" element={<FeaturedFreelancers />} />
              <Route path="/client/chat" element={<Chat />} />
              <Route path="/client/:id" element={<PublicClientProfile />} />

              {/* Admin routes */}
              <Route element={<AdminRoute />}>
                <Route path="/admin" element={<AdminPage />} />
              </Route>

              {/* Legacy route redirects for backward compatibility */}
              <Route path="/genius-profile" element={<Navigate to="/genius/profile" replace />} />
              <Route path="/client-profile" element={<Navigate to="/client/profile" replace />} />
              <Route path="/search" element={<Navigate to="/client/search" replace />} />
              <Route path="/featured-freelancers" element={<Navigate to="/client/featured" replace />} />
              <Route path="/courses" element={<Navigate to="/genius/courses" replace />} />
              <Route path="/course/:slug" element={<Navigate to="/genius/course/:slug" replace />} />
              <Route path="/lesson/:lessonId" element={<Navigate to="/genius/lesson/:lessonId" replace />} />
              <Route path="/client-search-data" element={<Navigate to="/genius/analytics" replace />} />
            </Route>
          </Route>
        </Route>

        {/* Catch-all redirect */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster />
    </>
  )
}

export default App
